// plop_marker:layouts_import
import BasicButton from "./basic-button/index.js";
export default {
    // plop_marker:layouts_add_layout
    BasicButton
};
